function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("rect", {
  x: 58.2,
  y: 35,
  className: "st0",
  width: 3.7,
  height: 13.1
}), React.createElement("polygon", {
  className: "st0",
  points: "111.7,42.5 111.7,48.1 108,48.1 108,34.6 114.6,39.9 114.6,35 118.2,35 118.2,48.6  "
}), React.createElement("path", {
  className: "st0",
  d: "M39.9,41.5c0-3.7,3.2-6.8,7.2-6.8c1.8,0,3.4,0.6,4.7,1.6l-2.4,2.5c-0.6-0.5-1.4-0.8-2.3-0.8 c-2,0-3.6,1.5-3.6,3.4c0,1.9,1.6,3.4,3.6,3.4c0.9,0,1.7-0.3,2.3-0.8l2.4,2.5c-1.3,1-2.9,1.7-4.7,1.7C43.1,48.3,39.9,45.2,39.9,41.5 "
}), React.createElement("polygon", {
  className: "st0",
  points: "68.8,51.1 61.9,33.8 56.2,33.8 56.2,48.2 52.4,48.2 52.4,33.8 44,33.8 46,30.4 64.6,30.4 68.8,40.7 73.1,30.4 91.1,30.4 93.1,33.8 75.8,33.8  "
}), React.createElement("path", {
  className: "st0",
  d: "M80.5,48.1v-2.9H83c0.4,0,1.2,0,1.4-0.6c0.4-1.3-3.7-3.3-3.7-6.5c0-2.4,1.8-3.1,3.1-3.1h3.8v2.9h-2.3 c0,0-0.7,0-0.9,0.3c-1,1.4,3.8,3.4,3.8,7.1c0,1.9-1.8,2.9-3.5,2.9H80.5z"
}), React.createElement("rect", {
  x: 75.8,
  y: 34.9,
  className: "st0",
  width: 3.7,
  height: 13.1
}), React.createElement("rect", {
  x: 88.7,
  y: 34.9,
  className: "st0",
  width: 3.7,
  height: 13.1
}), React.createElement("path", {
  className: "st0",
  d: "M32.7,42.2h2.2l-1.1-3.4L32.7,42.2z M37.1,48.1l-1-2.4h-4.5l-1,2.4h-3.9l7.1-19.2L41,48.1H37.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M96.7,41.5c0,1.9,1.6,3.4,3.6,3.4c2,0,3.6-1.5,3.6-3.4c0-1.9-1.6-3.4-3.6-3.4C98.2,38.2,96.7,39.7,96.7,41.5  M93,41.5c0-3.7,3.2-6.8,7.2-6.8c4,0,7.2,3,7.2,6.8c0,3.7-3.2,6.8-7.2,6.8C96.3,48.3,93,45.2,93,41.5"
}));

var SvgLogoActivision = function SvgLogoActivision(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 80",
    style: {
      enableBackground: "new 0 0 145 80"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/logo-activision.1da58a48.svg";
export { SvgLogoActivision as ReactComponent };